

import React, { useState, useEffect, useRef } from 'react';
import { useDataContext } from '../../contexts/DataContext';
import videojs from 'video.js';
// import { toDateString } from '../../cameraHelpers.js';
import "video.js/dist/video-js.css";
import { toDateString } from '../../pages/cameraHelpers';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import CameraAltIcon from '@material-ui/icons/CameraAlt';
import download from 'downloadjs';

import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { KeyboardReturnOutlined } from '@material-ui/icons';
import { analytics } from '../../firebase';

const aws =  require('aws-sdk');




export default function CameraViewer(props){

	const { routes, oldLocations } = useDataContext();
	// const newLocations = [2, 20, 21];

	const playerRef = useRef();
	const canvasRef = useRef();
	const wrapperRef = useRef();
	const snapshotRef = useRef();
	const dateTimeRef = useRef(new Date(1999, 1, 1)); // set arbitrary impossible date
	const [player, setPlayer] = useState();
	const [zoom, setZoom] = useState(1);

	console.log(props.currentLocation);

	aws.config.update({
		region: (props.currentLocation.franchise_id == 9 || props.currentLocation.franchise_id == 28 || props.currentLocation.franchise_id == 30 || props.currentLocation.franchise_id == 33 || props.currentLocation.franchise_id == 38 || props.currentLocation.franchise_id == 41) ? 'eu-west-1' : 'us-west-2',
		credentials: {
			accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
			secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY
		}
	});

	const kinesisOptions = {
		// ON_DEMAND - media playlist is typically static for sessions, LIVE - media playlist is continually updated with new fragments for sessions 
		PlaybackMode: 'LIVE',
		// NEVER /ALWAYS 
		DisplayFragmentTimestamp: 'ALWAYS',
		// how much time link is valid in seconds, this value can be between 300 (5 minutes) and 43200 (12 hours).
		Expires: 600, // 10 min
		// FRAGMENTED_MP4 - container format packages the media into MP4 fragments, MPEG_TS - only supported packaging on older HLS players, has a 5-25 % consts more 
		ContainerFormat: 'FRAGMENTED_MP4',
		// ALWAYS - recommended to use if fragment timestamps are not accurate,and server timestamp is selected, NEVER - option for producer timestamp, ON_DISCONTINUITY - adviced option for most cases, media player timeline is only reset when there is a significant issue with the media timeline (e.g. a missing fragment)
		DiscontinuityMode: 'ALWAYS',
		HLSFragmentSelector: {
			// PRODUCER_TIMESTAMP, SERVER_TIMESTAMP
			FragmentSelectorType: 'SERVER_TIMESTAMP',
		},
	};
	  
	  // create instance of kinesis video, pass AWS region as param 
	const kinesisVideo = new aws.KinesisVideo();
	
	async function getLiveStream(streamName) {
		// creating video stream endpoint
		const endpointObject = await kinesisVideo.getDataEndpoint({
			StreamName : streamName,
			APIName: 'GET_HLS_STREAMING_SESSION_URL',
		}).promise();
	
		if(endpointObject.DataEndpoint) {
			const data = {
				//get stream session url, url is valid from 5 min to 12 h. depending on hereabove options
				url : await getStreamSessionURL(endpointObject.DataEndpoint, streamName, kinesisOptions),
			}
			return data
		} else {
			throw new Error('Cannot get the url');
		}
	}
	
	async function getStreamSessionURL(endpoint, streamName, options) {
		// https://docs.aws.amazon.com/AWSJavaScriptSDK/latest/AWS/KinesisVideoArchivedMedia.html
		const kinesisVideoArchivedMedia = new aws.KinesisVideoArchivedMedia({
			region: (props.currentLocation.franchise_id == 9 || props.currentLocation.franchise_id == 28 || props.currentLocation.franchise_id == 30 || props.currentLocation.franchise_id == 33 || props.currentLocation.franchise_id == 38 || props.currentLocation.franchise_id == 41) ? 'eu-west-1' : 'us-west-2',
			endpoint: new aws.Endpoint(endpoint)
		})
		
		// get HLSS sourse of the stream as will use HLSS player. Other option is DASH - getDASHStreamingSessionURL
		const data = await kinesisVideoArchivedMedia.getHLSStreamingSessionURL({
			StreamName: streamName,
			...options,
		}).promise();

		return data.HLSStreamingSessionURL
	};

	const mobileCheck = () =>  {
		let check = false;
		(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
		// console.log("mobile check", check);
		return check;
	};

	const toggleLive = () => {
		// console.log("Getting call to toggle")
		// if (newLocations.indexOf(props.currentLocation.id) == -1){return}
		if (oldLocations.indexOf(props.currentLocation.id) != -1){return}
		if (player){
			if (props.isLive){
				// console.log("\n\n\nRefreshing Live\n\n\n")
				let currentSource = player.currentSrc();
				player.src({
					src: currentSource,
					type: "application/x-mpegURL"
				});
				player.play();
			}
			else{
				// console.log("\n\n\nNot refreshing because not live\n\n\n")
			}
		}
	}

	// Note we need a new use effect that changes any time the states
	// that are used to do the toggle are changed, otherwise
	// the interval function will be created once, and never update no matter
	// what states have changed
	useEffect(() => {
		// console.log("Setting interval");
		let id = setInterval(toggleLive, 3 * 60 * 1000);
		return () => {clearInterval(id)}
	}, [props.isLive, player])

	// On Load setup player
	useEffect(() => {
		// Create the videojs object
		const p = videojs(
			playerRef.current,
			{
				autoplay: true, 
				// muted: mobileCheck() ? false : true, 
				muted: true,
				playsinline: true,
				// fill:true,
				// fluid:true,
				// html5:{overrideNative: true},
				html5: {vhs: {overrideNative: false}},
				// fluid: true,
				// aspectRatio: '9:16'
			}
		);
		// p.width(800);


		// Deal wtih non-existtant video file skippinng
		p.tech_.on("retryplaylist", () => {
			// console.log("Problem with", props.camera);
			p.currentTime(p.currentTime() + 17);
		});

		// On exiting full screen make sure we track that
		p.on("fullscreenchange", (e) => {
			if (!p.isFullscreen()){
				props.setFullScreen();
			}
		});

		p.on("play", (e) => {
			// console.log("Play event");
			props.setIsPlaying(true);
		})

		p.on("pause", (e) => {
			// console.log("Pause event");
			props.setIsPlaying(false);
		})

		// p.on("seeking", (e) => {
		// 	console.log("Seeking event", e);
		// })

		// p.on("seeked", (e) => {
		// 	console.log("Seeked event--has jumped to new time", e);
		// 	console.log("New current time", p.currentTime());
		// })

		p.on("loadedmetadata", (e) => {
			let w = wrapperRef.current.clientWidth;
			p.width(w);
		})

		p.on('canplay', (e) => {
			// console.log("Can Play", props.ind);
			props.updateCanPlay(true, props.ind);
		})

		p.on('error', (e) => {
			// Often triggered by an issue with the playlist
			// which comes from server side, can usaully by fixed by
			// refreshing the video
			console.warn(e);
			let currentSource = p.currentSrc();
			p.src({
				src: currentSource,
				type: "application/x-mpegURL"
			});
			p.play();
		})

		// p.on('sourceset', (e) => {
		// 	console.log("Source SEt");
		// })

		// Set player state
		setPlayer(p);

		let _resize = () => {
			// console.log("_resize");
			if (p){
				let w = wrapperRef.current.clientWidth;
				p.width(w);
			}
		}
		window.addEventListener('resize', _resize);

		// set internal for refreshing
		// let refreshId = setInterval(() => {
		// 	// if (props.isLive){
		// 	// if (getLiveStatus()){
		// 	// 	console.log("refreshing live");
		// 	// 	let currentSource = p.currentSrc();
		// 	// 	p.src({
		// 	// 		src: currentSource,
		// 	// 		type: "application/x-mpegURL"
		// 	// 	});
		// 	// 	p.play();
		// 	// }
		// 	console.log("\n\n\nRunning interval to toggle live\n\n\n");
		// 	toggleLive();
		// }, .5 * 60 * 1000); // refresh every 3 minutes

		// set(_resize, 1000);

		analytics.logEvent('view_video', {'location': props.currentLocation.id, 'camera': props.camera});

		// Cleanup
		return () => {
			// Stop interval for live refresh
			// clearInterval(refreshId);

			if (player){
				console.log("dispsing of player");
				player.dispose();
			}

			if (p){
				console.log("dispsing of player P!");
				p.dispose();
			}

			window.removeEventListener('resize', _resize);
		}
	}, []);
	

	// On Change of date to update source
	useEffect(() => {
		if ( (props.videoDateTime != undefined) & (player != undefined) ){
			// Catch for live at start
			if (props.isLive){
				goToLive();
				player.play();
				// if (!mobileCheck()){
				// 	player.play();
				// }
				return;
			}

			// If date is different update source
			let prevSplit = toDateString(dateTimeRef.current).split('T');
			let newSplit = toDateString(props.videoDateTime).split('T')
			let prevDate = prevSplit[0];
			let newDate = newSplit[0];
			if (prevDate != newDate){
				updateVideoSource();
			}

			// if Time is different move video to new time
			let newTime = newSplit[1];
			let prevTime = prevSplit[1];
			let hour = parseInt(newTime.split(":")[0]);
			let minute = parseInt(newTime.split(":")[1]);
			jumpTo(hour, minute);
			// if ( (newTime != prevTime) | (prevDate != newDate)){
			// 	let hour = parseInt(newTime.split(":")[0]);
			// 	let minute = parseInt(newTime.split(":")[1]);
			// 	jumpTo(hour, minute);
			// }

			// Update refs
			dateTimeRef.current = props.videoDateTime;
			player.play();
			// Autoplay
			// if (!mobileCheck()){
			// 	player.play();
			// }
		}
	}, [props.videoDateTime, player]);

	/**
	 * Play or pause the video based on isPlaying prop
	 */
	useEffect(() => {
		// if (mobileCheck()){return}
		if (player){
			if (props.isPlaying){
				player.play();
			}
			else{
				player.pause();
			}
		}
	}, [props.isPlaying])

	/**
	 * Fast forward and rewind hooks to move the video forward or back
	 */
	useEffect(() => {
		if (player){
			// if ((props.currentLocation.id == 2){
			// if (newLocations.indexOf(props.currentLocation.id) != -1){
			if (oldLocations.indexOf(props.currentLocation.id) == -1){
				// for real ones do a real 10 minute jump
				// console.log("Crenshaw hack FF");
				player.currentTime(player.currentTime() + 300);
				return;
			}
			player.currentTime(player.currentTime() + 100);
		}
	}, [props.fastForwardCount])

	useEffect(() => {
		if (player){
			// if (props.currentLocation.id == 2){
			// if (newLocations.indexOf(props.currentLocation.id) != -1){
			if (oldLocations.indexOf(props.currentLocation.id) == -1){
				// console.log("Crenshaw Hack Rewind");
				player.currentTime(player.currentTime() - 300);
				return;
			}
			player.currentTime(player.currentTime() - 100);
		}
	}, [props.rewindCount])


	/**
	 * Playback speed update
	 */
	useEffect(() => {
		if (player){
			player.playbackRate(props.speed);
			player.defaultPlaybackRate(props.speed);
		}
	}, [props.speed])

	/**
	 * Show full screen if this one is selected
	 */
	useEffect(() => {
		if (player){
			if (props.fullScreen == props.camera){
				player.requestFullscreen();
			}
		}
	}, [props.fullScreen])

	useEffect(() => {
		if (player){
			if (props.isLive){
				// if ( (props.currentLocation.id == 2) || (props.currentLocation.id == 20)){
				goToLive();
			}
			else{
				// Not live, so go back to normal feed
				// console.log("Go back to normal feed");
				updateVideoSource();

				// Go to right time in the video
				let dt = toDateString(props.videoDateTime).split('T');
				let time = dt[1]
				let hour = parseInt(time.split(":")[0]);
				let minute = parseInt(time.split(":")[1]);
				jumpTo(hour, minute);
			}
			player.play();
			// if (!mobileCheck()){
			// 	player.play();
			// }
			
		}
	}, [props.isLive])

	// Resize the cameras if the grid option is changed
	useEffect(() => {
		// console.log("Grid triggered camera resize");
		let tid = setTimeout(resize, 400);
		return () => {clearTimeout(tid)}
	}, [props.grid, props.resizeCounter])


	const goToLive = () => {
		// if (newLocations.indexOf(props.currentLocation.id) != -1){
		if (player === undefined) {
			return;
		}
		if (props.currentLocation.id == 27) {
			getLiveStream(`${props.currentLocation.id}_${props.camera}`).then((value) => {
				player.src({
					src: value.url,
					type: "application/x-mpegURL"
				});
				player.playbackRate(1);
				player.defaultPlaybackRate(1);
			});
		}
		else if (oldLocations.indexOf(props.currentLocation.id) == -1){
			player.src({
				src: `https://live.hellometer.io/home/live/${props.currentLocation.id}/live${props.camera}.m3u8`,
				type: "application/x-mpegURL"
			});
			player.playbackRate(1);
			player.defaultPlaybackRate(1);
		}
	}

	const updateVideoSource = () => {
		let base = routes['playlist'];

		// get time in UTC if crenshaw
		let datetime = props.videoDateTime;
		let rand = Math.floor(Math.random()*1000);
		let newSrc = `${base}?location=${props.currentLocation.id}&date=${toDateString(datetime)}&camera=${props.camera}&timezone=${props.currentLocation.time_zone}`
		player.src({
				src: newSrc,
				type: "application/x-mpegURL",
		});

		player.playbackRate(props.speed);
		player.defaultPlaybackRate(props.speed);

		// if (mobileCheck()){return}
	}

	const jumpTo = (hour, minute) => {
		let approxTime = (hour + (minute/60)) * 1000;
		// if (props.currentLocation.id == 2){
		// if (newLocations.indexOf(props.currentLocation.id) != -1){	
		if (oldLocations.indexOf(props.currentLocation.id) == -1){
			// Crenshaw has different video lengths
			// console.log("Jumping in Crenshaw");
			approxTime = hour*60*60 + minute*60 - 60; // -120 is just a small tweaks
		}
		player.currentTime(approxTime);
		// props.setIsPlaying(true); // <--- fix bug where when paused and switch source, video plays but icon doesn't
		// if (mobileCheck()){return}
		// player.play();
	}


	const snapshot = () => {
		// set the canvas dimensions
		canvasRef.current.width = playerRef.current.videoWidth;
		canvasRef.current.height = playerRef.current.videoHeight;
		canvasRef.current.getContext('2d').drawImage(playerRef.current, 0, 0, 
					playerRef.current.videoWidth, playerRef.current.videoHeight);
		canvasRef.current.toBlob( (blob) => {
			download(blob, 'snapshot.jpg', 'img/jpeg');
		} );

	}

	const resize = () => {
		if (player){
			let w = wrapperRef.current.clientWidth;
			player.width(w);
		}
	}

	

	return(
		<>
			<div className='flow-root'>
				<h3 className='m-3 float-left'>Camera: {props.camera}</h3>
				<div className={`float-right pr-3 pt-3 ${mobileCheck() ? 'hidden' : ''}`}>
					<IconButton onClick={snapshot}  ref={snapshotRef} size='small'>
						<CameraAltIcon className='cameraIcon'/>
					</IconButton>
				</div>
			</div>
			<div data-vjs-player ref={wrapperRef} className='overflow-hidden rounded-b-lg'>
				<TransformWrapper>
					<TransformComponent>
						<video
							controls // <--------------- we want to get rid of these when dev is donen
							muted
							playsInline
							autoPlay
							ref={playerRef}
							className="video-js"
							>
						</video>
					</TransformComponent>
				</TransformWrapper>
			</div>
			<canvas id="canvas" style={{"overflow":"auto", 'display':'none'}} ref={canvasRef}></canvas>
			

		</>
	)
}
